import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import AccueilDashboard from '../../Accueil/AccueilDashboard';
import Alarmes from './Alarmes/Alarmes';
import Graphe from './GrapheClient/Graphe';
import TableauxDeBord from './TableauxDeBord/TableauxDeBord';
import Vues from './Vues/Vues';

import { checkMot } from '../../../ressources/functionJS/checkMot';

import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import S from './OngletsClient.module.scss';
import Rapports from './Rapports/Rapports';

const TAB_PLANS = checkMot('plans');
const TAB_TDB = checkMot('tableaux_de_bord');
const TAB_GRAPHES = checkMot('graphes');
const TAB_ALARMES = checkMot('alarmes');
const TAB_RAPPORTS = checkMot('rapports');
const TAB_ACCUEIL = checkMot('accueil');

const TAB_PRIORITY = [TAB_PLANS, TAB_TDB, TAB_GRAPHES];

function OngletsClient({ montrerMenu, inProjectContext = false }) {
  const [toggleState, setToggleState] = useState(
    inProjectContext ? TAB_PLANS : TAB_ACCUEIL
  );
  const [transitioning, setTransitioning] = useState(false);
  const history = useHistory();
  const userInteracted = useRef(false);

  const [tabsWithContent, setTabsWithContent] = useState({
    [TAB_PLANS]: false,
    [TAB_TDB]: false,
    [TAB_GRAPHES]: false,
  });

  // Auto-select first tab with content in project context (before user interacts)
  useEffect(() => {
    if (!inProjectContext || userInteracted.current) return;
    const firstTab = TAB_PRIORITY.find((tab) => tabsWithContent[tab]);
    if (firstTab && firstTab !== toggleState) {
      setToggleState(firstTab);
    }
  }, [tabsWithContent, inProjectContext, toggleState]);

  const handleTabClick = (index) => {
    if (index === TAB_ACCUEIL && window.location.pathname !== '/') {
      history.push('/');
      return;
    }
    if (index === toggleState) return;
    userInteracted.current = true;
    setTransitioning(true);
    setTimeout(() => {
      setToggleState(index);
      setTransitioning(false);
    }, 250);
  };

  const makeContentCallback = useCallback(
    (tabKey) => (hasContent) =>
      setTabsWithContent((prev) =>
        prev[tabKey] === hasContent ? prev : { ...prev, [tabKey]: hasContent }
      ),
    []
  );

  const plansBoolChange = useCallback(makeContentCallback(TAB_PLANS), []); // eslint-disable-line
  const tableaux_de_bordBoolChange = useCallback(
    makeContentCallback(TAB_TDB),
    []
  ); // eslint-disable-line
  const graphesBoolChange = useCallback(makeContentCallback(TAB_GRAPHES), []); // eslint-disable-line
  const alarmesBoolChange = useCallback(() => {}, []);
  const rapportsBoolChange = useCallback(() => {}, []);
  const isAccueilPage = window.location.pathname === '/';
  const favorisSuffix = isAccueilPage ? ` ${checkMot('favoris')}` : '';

  return (
    <div className={[S.container, S.fade_in_image].join(' ')}>
      <div className={S.bloc_tabs}>
        <button
          className={toggleState === TAB_ACCUEIL ? S.activeTabs : S.tabs}
          onClick={() => handleTabClick(TAB_ACCUEIL)}
        >
          {`${checkMot('Accueil')}`}
        </button>
        <button
          className={toggleState === TAB_PLANS ? S.activeTabs : S.tabs}
          onClick={() => handleTabClick(TAB_PLANS)}
        >
          {`${checkMot('plans')} ${favorisSuffix}`}
        </button>
        <button
          className={toggleState === TAB_TDB ? S.activeTabs : S.tabs}
          onClick={() => handleTabClick(TAB_TDB)}
        >
          {`${checkMot('tableaux_de_bord')} ${favorisSuffix}`}
        </button>
        <button
          className={toggleState === TAB_GRAPHES ? S.activeTabs : S.tabs}
          onClick={() => handleTabClick(TAB_GRAPHES)}
        >
          {`${checkMot('graphes')} ${favorisSuffix}`}
        </button>
        <button
          className={toggleState === TAB_ALARMES ? S.activeTabs : S.tabs}
          onClick={() => handleTabClick(TAB_ALARMES)}
        >
          {`${checkMot('alarmes')}`}
        </button>
        <button
          className={toggleState === TAB_RAPPORTS ? S.activeTabs : S.tabs}
          onClick={() => handleTabClick(TAB_RAPPORTS)}
        >
          {`${checkMot('rapports')}`}
        </button>
      </div>
      {/*corps après sélections d'un onglet*/}
      <div className={S.contentTabs}>
        {transitioning && (
          <div className={S.loadingOverlay}>
            <div className={S.spinner} />
          </div>
        )}
        {toggleState === TAB_ACCUEIL && (
          <div className={[S.content, S.activeContent].join(' ')}>
            <AccueilDashboard />
          </div>
        )}
        <div
          className={
            toggleState === TAB_PLANS
              ? [S.content, S.activeContent].join(' ')
              : S.content
          }
        >
          {toggleState === TAB_PLANS && (
            <Vues siLaListeAUneValeur={plansBoolChange} />
          )}
        </div>
        <div
          className={
            toggleState === TAB_TDB
              ? [S.content, S.activeContent].join(' ')
              : S.content
          }
        >
          {toggleState === TAB_TDB && (
            <TableauxDeBord siLaListeAUneValeur={tableaux_de_bordBoolChange} />
          )}
        </div>
        <div
          className={
            toggleState === TAB_GRAPHES
              ? [S.content, S.activeContent].join(' ')
              : S.content
          }
        >
          {toggleState === TAB_GRAPHES && (
            <Graphe siLaListeAUneValeur={graphesBoolChange} />
          )}
        </div>
        {toggleState === TAB_ALARMES && (
          <div className={[S.content, S.activeContent].join(' ')}>
            <Alarmes siLaListeAUneValeur={alarmesBoolChange} />
          </div>
        )}
        {toggleState === TAB_RAPPORTS && (
          <div className={[S.content, S.activeContent].join(' ')}>
            <Rapports siLaListeAUneValeur={rapportsBoolChange} />
          </div>
        )}
      </div>
    </div>
  );
}

export default OngletsClient;
